import { useState, useMemo } from "react";

/**
 * Hook for sorting table data by a single column.
 * Cycles: null (no sort) -> "asc" -> "desc" -> null
 */
export const useTableSort = (items) => {
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const onSort = (column) => {
    if (sortColumn !== column) {
      setSortColumn(column);
      setSortDirection("asc");
    } else if (sortDirection === "asc") {
      setSortDirection("desc");
    } else {
      setSortColumn(null);
      setSortDirection(null);
    }
  };

  const sortedItems = useMemo(() => {
    if (!sortColumn || !sortDirection) return items;

    return [...items].sort((a, b) => {
      const valA = a[sortColumn] || "";
      const valB = b[sortColumn] || "";
      const cmp = valA.localeCompare(valB);
      return sortDirection === "asc" ? cmp : -cmp;
    });
  }, [items, sortColumn, sortDirection]);

  return { sortedItems, sortColumn, sortDirection, onSort };
};